export default function Viewer({next, router}) {
    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth-2')) {
        return router.push({ name: 'login' });
    }

    return next();
}



// WEBPACK FOOTER //
// ./src/middleware/Viewer.js